const state = {
  guest_book: [],
};

export default state;
